import { NavigationService } from "@/shared/services/NavigationService";
import { SystemView } from "@/shared/constants/Views.enum";
import { Component, Inject, Vue, Watch } from "vue-property-decorator";
import { STYLE_CLASSES } from "../../shared/constants/StyleConstants";
import EmptyState from "@/shared/components/EmptyState/EmptyState.vue";
import ScrollBottom from "../../shared/components/ScrollBottom/ScrollBottom.vue";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
import ObservationModal from "@/shared/components/ObservationModal/ObservationModal.vue";
import ListItem from "@/shared/components/ListItem/ListItem.vue";
import {
  COLLECTIONS_NAME,
  COMPONENT_NAME_MODAL,
  FORM_MESSAGES,
  LIST_DATA_EVENTS
} from "../../shared/constants/FormConstants";
import { Response } from "@/shared/models/Response";
import { Http } from "@status/codes";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { QuerySendMultiple } from "../../shared/models/FormQuerySend";
import {
  NAME_FINDERS,
  PANEL_INFO_CONSTANTS,
  STATE,
  STORE_CONSTANTS
} from "@/shared/constants/GeneralConstants";
import {
  DEPENDENCIES_ACCESS,
  DEPENDENCIES_CONSTANTS,
  DEPENDENCIES_FILTERS
} from "./constants/DependenciesConstants";
import { DependencyPagination } from "./models/DependencyPaginatinaton";
import { Dependency } from "./models/Dependency";
import { DependenciesService } from "./services/DependenciesService";
import { MenuDataStructure } from "@/shared/models/MenuDataStructure";
import store from "@/store";
import { SearchContextModal } from "@/shared/models/SearchContextModal";
import { mapGetters } from "vuex";
import { Utils } from "@/shared/utils/utils";
import GenericSearchBar from "@/shared/components/GenericSearchBar/GenericSearchBar.vue";
import { Filter } from "../Dashboards/AdminDashboard/models/Filter";
import lodash from "lodash";
import { AxiosError } from "axios";

@Component({
  name: "Dependencies",
  components: {
    EmptyState,
    ScrollBottom,
    ListItem,
    ModalTemplate,
    ObservationModal,
    GenericSearchBar
  },
  computed: {
    ...mapGetters({
      dataToMainView: "getDataToMainView"
    })
  }
})
export default class Dependencies extends Vue {
  @Inject() dependenciesService!: DependenciesService;

  PAGE_TITLE = DEPENDENCIES_CONSTANTS.TITLE.PPAL_PAGE;
  ADD_DEPENDENCY_LBL = DEPENDENCIES_CONSTANTS.LABEL.ADD_DEPENDENCY;
  EMPTY_STATE_HEADER = FORM_MESSAGES.INFO_MESSAGE.NO_INFO_TO_SHOW;
  EMPTY_STATE_PARAGRAPH = FORM_MESSAGES.INFO_MESSAGE.EMPTY_STATE_TEXT;
  CLICK_ACTION = LIST_DATA_EVENTS.EDIT_DATA;

  primaryBtnRoundClass = STYLE_CLASSES.PRIMARY_ROUND_BTN;

  operations: string[] = [];
  filterItems: {
    name?: string[];
    state?: string[];
  } = {};
  filterArray: Filter[] = lodash.cloneDeep(DEPENDENCIES_FILTERS) as Filter[];
  loadingData = false;
  showCardsContainer = false;
  canSearch = true;
  dependenciesList!: Dependency[];
  docRef = "";

  requestDependenciesData!: Response<DependencyPagination>;
  actionMode = "";
  itemState = "";
  dialogDelete = false;
  dialogObservation = false;
  observationModalTitle = FORM_MESSAGES.DELETE_MODAL.TITLE;
  observationModalText = FORM_MESSAGES.DELETE_MODAL.MESSAGE;
  modalTitle = FORM_MESSAGES.DELETE_MODAL.TITLE;
  modalText = FORM_MESSAGES.DELETE_MODAL.MESSAGE;
  modalVoidedData = { ...FORM_MESSAGES.DESACTIVED_MODAL };
  SEARCH_DEPENEDENCIES_KEY = NAME_FINDERS.DEPENEDENCIES;

  dataToMainView!: MenuDataStructure;
  /* eslint-disable-next-line  @typescript-eslint/no-empty-function */
  callbackHandleContextPanel: Function = () => {};
  showButtonCreate = false;

  @Watch("dataToMainView")
  dataToMainViewHandler() {
    const validations: Record<string, void> = {
      Panel: this.panelValidation()
    };
    validations[this.dataToMainView.from];
  }

  panelValidation() {
    if (
      this.dataToMainView.from === PANEL_INFO_CONSTANTS.FROM.PANEL &&
      this.dataToMainView.type === PANEL_INFO_CONSTANTS.TYPE.SEARCH &&
      this.dataToMainView.action === PANEL_INFO_CONSTANTS.ACTION.FUNTION_MODAL
    ) {
      this.callbackHandleContextPanel = this.dataToMainView.data;
    }
  }

  sendDataToLateralMenu(action: string, data?: unknown) {
    this.showButtonCreate = this.operations.includes(
      LIST_DATA_EVENTS.SAVE_DATA
    );
    store.commit(STORE_CONSTANTS.TO_LATERAL_MENU, {
      from: PANEL_INFO_CONSTANTS.FROM.CRUD,
      type: PANEL_INFO_CONSTANTS.TYPE.SEARCH,
      action: action,
      data: data
    });
  }

  emitModalInitializer() {
    const searchContext: SearchContextModal = {
      callbackHandleOperation: this.handleOperation,
      componentName: COMPONENT_NAME_MODAL.CAMPUS
    };
    const data = {
      ...searchContext
    };
    this.sendDataToLateralMenu(PANEL_INFO_CONSTANTS.ACTION.FUNTION_MODAL, data);
  }

  mounted() {
    this.operations = Utils.addExtraOperations(
      this.operations,
      COLLECTIONS_NAME.DEPENDENCY
    );

    this.searchData({ state: [STATE.ACTIVE] });
    this.emitModalInitializer();
  }

  async searchData(data: any) {
    this.loadingData = true;
    this.showCardsContainer = false;
    this.canSearch = false;
    this.dependenciesList = [];

    delete data["mainFilterKey"];

    this.filterItems = { ...data };

    this.requestDependenciesData = await this.getDataByFilter();

    if (
      this.requestDependenciesData.code === Http.Found &&
      this.requestDependenciesData.data !== undefined
    ) {
      this.dependenciesList = this.requestDependenciesData.data.data;
      this.docRef = this.requestDependenciesData.data.docRef;
      this.showCardsContainer = true;
      this.canSearch = true;
    } else {
      if (this.requestDependenciesData.code === Http.NotFound) {
        Snackbar.popInfo(this.requestDependenciesData.message);
      } else {
        Snackbar.popError(this.requestDependenciesData.message);
      }
    }

    this.loadingData = false;
  }

  async onBottom() {
    if (this.canSearch && !this.loadingData) {
      this.loadingData = true;
      this.requestDependenciesData = await this.getDataByFilter(true);

      if (
        this.requestDependenciesData.code === Http.Found &&
        this.requestDependenciesData.data !== undefined
      ) {
        if (this.requestDependenciesData.data.docRef !== this.docRef) {
          this.dependenciesList = this.dependenciesList.concat(
            this.requestDependenciesData.data.data
          );
          this.docRef = this.requestDependenciesData.data.docRef;
        } else {
          this.canSearch = false;
        }
      } else if (this.requestDependenciesData.code === Http.NotFound) {
        this.canSearch = false;
      } else {
        Snackbar.popError(this.requestDependenciesData.message);
        this.canSearch = false;
      }
      this.loadingData = false;
    }
  }

  async getDataByFilter(
    loadPages?: boolean
  ): Promise<Response<DependencyPagination>> {
    try {
      const filterQuery: QuerySendMultiple = {
        state: ["Activo"]
      };

      if (this.filterItems.state) filterQuery.state = this.filterItems.state;

      if (this.filterItems.name) filterQuery.name = this.filterItems.name[0];

      if (loadPages) filterQuery.docref = this.docRef;

      const responseData = await this.dependenciesService.getDependenciesWithFilters(
        filterQuery
      );
      return responseData;
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden) {
        const RESPONSE_ERROR: Response<DependencyPagination> = {
          code: Http.Forbidden,
          message: FORM_MESSAGES.FORBIDDEN_REQUEST + DEPENDENCIES_ACCESS.GET
        };
        return RESPONSE_ERROR;
      } else {
        const RESPONSE_ERROR: Response<DependencyPagination> = {
          code: Http.Forbidden,
          message: FORM_MESSAGES.REQUEST_FAILED
        };
        return RESPONSE_ERROR;
      }
    }
  }

  async handleOperation(action: string, itemId: string) {
    switch (action) {
      case LIST_DATA_EVENTS.EDIT_DATA:
        this.editDependency(itemId);
        break;
      case LIST_DATA_EVENTS.DELETE_DATA:
        this.deleteDependency(itemId);
        break;
      case LIST_DATA_EVENTS.ACTIVE_DATA:
        this.updateStateDependency(itemId, STATE.ACTIVE);
        break;
      case LIST_DATA_EVENTS.DESACTIVED_DATA:
        this.updateStateDependency(itemId, STATE.INACTIVE);
        break;
    }
  }

  editDependency(itemId: string) {
    NavigationService.navigateTo(SystemView.SAVE_DEPENDENCIES, {
      id: itemId
    });
  }

  async updateStateDependency(documentId: string, state: string) {
    try {
      const responseData = await this.dependenciesService.updateStateDependency(
        documentId,
        state
      );

      if (responseData.code === Http.Ok) {
        Snackbar.popSuccess(responseData.message);
        await this.searchData({ state: [STATE.ACTIVE] });
      } else {
        Snackbar.popError(responseData.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + DEPENDENCIES_ACCESS.PUT
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async deleteDependency(selectedId: string) {
    try {
      const responseData = await this.dependenciesService.deleteDependency(
        selectedId
      );

      if (responseData.code === Http.Ok) {
        Snackbar.popSuccess(responseData.message);
        await this.searchData({ state: [STATE.ACTIVE] });
      } else if (responseData.code === Http.Found) {
        Snackbar.popWarning(DEPENDENCIES_CONSTANTS.MESSAGES.DEPENDENCY_USED);
      } else {
        Snackbar.popError(responseData.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + DEPENDENCIES_ACCESS.DELETE
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  showCrudSave() {
    NavigationService.navigateTo(SystemView.SAVE_DEPENDENCIES);
  }
}
